export default __webpack_public_path__ + "static/media/export.99456eac.svg";